/**
 * @fileoverview Class name utility function
 * 
 * Utility for merging Tailwind CSS class names with conditional logic.
 * Based on clsx and tailwind-merge for optimal class merging.
 * 
 * @module ui/shared/utils/cn
 */

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges class names with Tailwind CSS conflict resolution
 * 
 * Combines clsx for conditional classes and tailwind-merge to resolve
 * Tailwind class conflicts (e.g., "p-2" and "p-4" -> "p-4").
 * 
 * @param {...ClassValue} inputs - Class names or conditional class objects
 * @returns {string} Merged class string
 * 
 * @example
 * cn("px-2 py-1", "bg-red-500", isActive && "bg-blue-500")
 * // Returns: "px-2 py-1 bg-blue-500" (if isActive is true)
 * 
 * @example
 * cn("p-2", "p-4") // Returns: "p-4" (conflict resolved)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

